import { styled } from 'styled-components'
import { COLORS } from 'consts/colors'

export const MyProjectsBlock = styled.div`
  border-bottom: 1px solid ${COLORS.secondaryLight};
  box-sizing: border-box;
`
